import React from "react";
import Policy from "../components/Policy";

const PolicyPage = () => {
    return (
        <>
            <Policy />
        </>
    );
};

export default PolicyPage;
